import { useReducer } from 'react'

const init = (initialState) => initialState

const reducer = (state, { type, name, value, checked, payload }) => {
  if (type === 'RESET') return init(payload)

  return { ...state, [name]: type === 'checkbox' ? checked : value }
}

type Props = {
  initialState: {},
}

const useForm = (initialState: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState, init)

  const onChange = (e) => dispatch(e.target)

  const reset = () => dispatch({ type: 'RESET', payload: initialState })

  return [state, onChange, reset]
}

export default useForm
